import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { checkDate } from "common/helpers/Date";

export const estimateComparisonLinkFromJSON = (
  json: Partial<IEstimateComparisonLinkData>,
): EstimateComparisonLinkRecord => {
  const record: IEstimateComparisonLinkRecord = { ...(json as any) };

  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  return new EstimateComparisonLinkRecord(record);
};

export interface IEstimateComparisonLinkData {
  estimate_id: number;
  id: number;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
  _destroy?: Nullable<boolean>;
}

export interface IEstimateComparisonLinkRecord {
  estimate_id: number;
  id: number;
  created_at: Date;
  updated_at: Date;
  _destroy: Nullable<boolean>;
}

export const defaultEstimateComparisonLinkProps: IEstimateComparisonLinkRecord = {
  id: 0,
  estimate_id: 0,
  created_at: new Date(),
  updated_at: new Date(),
  _destroy: null,
};

export class EstimateComparisonLinkRecord
  extends Record(defaultEstimateComparisonLinkProps)
  implements IEstimateComparisonLinkRecord {}
